import { OnInit, Input, Component, Output } from "@angular/core";
import { Kursteilnehmer } from "../_models/teilnehmer";
import { TeilnehmerService } from "../_services/teilnehmer.service";
import { EventEmitter } from "@angular/core";
import { Kurs } from "../_models/kurs";
import { KursService } from "../_services/kurs.service";

@Component({
  selector: 'student-search',
  templateUrl: 'studentSearch.component.html'
})

export class StudentSearchComponent implements OnInit {
  @Output() student: Kursteilnehmer = null;
  searchField: string = '';
  studentsFound: Kursteilnehmer[] = null;
  courses: Kurs[];

  courseName(studCourseNumber: number): string {
    
    return this.courses.filter(c => c.kursNr == studCourseNumber)[0].kursName;
  }

  @Output() studentChanged: EventEmitter<Kursteilnehmer> = new EventEmitter<Kursteilnehmer>();

  constructor(private studentService: TeilnehmerService, private courseService: KursService) { }

  ngOnInit() {
    this.courseService.getKurse().subscribe(x => this.courses = x, err => console.log(err));
  }

  //findStudent(searchString: string): void {
  //  this.studentService.GetStudentByName(searchString).subscribe(
  //    resp => { this.studentsFound = resp;},
  //    err => { console.log(err);},
  //    () => {
  //      this.studentsFound = this.studentsFound.map(t => {
  //       if (this.courses.filter(c => t.kursNr == c.kursNr)[0].kursEnde.substr(0, 10) >
  //          new Date(Date.now()).toISOString().substr(0, 10)) return t;
  //      })
  //      this.studentsFound = this.studentsFound.sort((x, y) => x.nachname.localeCompare(y.nachname));
  //    }
  //  );
  //}

  findStudent(searchString: string): void {
    this.studentService.GetStudentByName(searchString).subscribe(
      resp => { this.studentsFound = resp; },
      err => { console.log(err); },
      () => {
        //Filtern falls Kurs schon beendet!
        //this.studentsFound = this.studentsFound.filter(t => {
        //  if (this.courses.filter(c => t.kursNr == c.kursNr)[0].kursEnde.substr(0, 10) >
        //    new Date(Date.now()).toISOString().substr(0, 10)) return true;
        //  else return false;
        //});
        this.studentsFound = this.studentsFound.sort((x, y) => x.nachname.localeCompare(y.nachname));
      }
    );
  }

  checkStudents() {
    this.student = null;
    this.studentsFound = null;
    if (this.searchField.length > 3) this.findStudent(this.searchField);
  }

  searchStudent() {
    this.studentsFound = null;
    this.findStudent(this.searchField);
  }

  chooseStudent(event) {
    let studentId: number;
    if (event.target.id == "")
      studentId = event.target.parentElement.id.substring(2);
    else
      studentId = event.target.id.substring(2);
    this.student = (this.studentsFound.find(stud => stud.kursteilnehmerNr == studentId));
    this.searchField = "";
    this.studentsFound = null;
    this.onStudentChange();
  }

  onStudentChange() {
    this.studentChanged.emit(this.student);
  }
}



// WEBPACK FOOTER //
// ./src/app/_components/studentSearch.component.ts